import React from 'react';
import FavoriteRoundedIcon from '@material-ui/icons/FavoriteRounded';
import { TypographyProps } from '@material-ui/core/Typography';
import T from 'i18n-react';
import Small from './Small';
import pink from '@material-ui/core/colors/pink';

type ReviewProps = TypographyProps & { rating: number, totalCount: number };

const Review = ({ rating, totalCount, ...props }: ReviewProps) => {
  return (
    <Small variant="body2" {...props}>
      <FavoriteRoundedIcon
        htmlColor={pink[300]}
        fontSize="small"
        style={{ verticalAlign: 'middle' }}
      />
      &nbsp;
      <span style={{ verticalAlign: 'middle' }}>
        {T.translate('business.reviewSummary', { rating, totalCount })}
      </span>
    </Small>
  );
};

export default Review;
